/**
 * Crypto constants used across the application
 * Follows naming conventions similar to Bouncy Castle for consistency
 */
export const CRYPTO_CONSTANTS = {
  // Algorithm names
  ENCRYPTION_ALGORITHM: "RSA",

  // Padding modes
  ENCRYPTION_PADDING_SHA256: "RSA-OAEP" as const,
  ENCRYPTION_PADDING_SHA1: "RSA-OAEP" as const,
  ENCRYPTION_PADDING_PKCS1: "RSAES-PKCS1-V1_5" as const,

  // Default hash algorithm
  DEFAULT_HASH_ALGORITHM: "sha256",

  // Provider name (mimicking Bouncy Castle's BC provider)
  PROVIDER_NAME: "NODE-FORGE",

  // Compatibility mode for backend
  COMPATIBILITY_MODE_JAVA: "RSA/ECB/OAEPWithSHA-256AndMGF1Padding",
};
